import Modal from "@/common/elements/Modal";
import SignaturesForm from "./SignaturesForm";
import { useEffect, useState } from "react";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import useDialog from "@/hooks/useDialog";
import { Form } from "antd";
import { useSelector } from "react-redux";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { MODULES_LIST_WITH_ID, SUB_MODULES_LIST_WITH_ID } from "@/util/common_variable";

const SignaturesFormModal = ({
  show,
  onHide,
  selectSignatureData,
  onSave,
  isEdit,
}) => {
  const { showDialog } = useDialog();
  const { bookingsFieldsEnabled } = useSelector((state) => state?.bookings);
  const [formValues, setFormValues] = useState(null);
  const [form] = Form.useForm();
  const [signImgPayload, setSignImgPayload] = useState(null);
  const [isSignImgUploaded, setIsSignImgUploaded] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false);
  const fullSearch = useSelector(state => state.fullSearch);
  useEffect(() => {
    if (isNonEmptyVariable(selectSignatureData) && isEdit) {
      setFormValues({
        signatureReasonID:
          selectSignatureData?.signature?.[0]?.signatureReasonID || "",
        legalese: selectSignatureData?.signature?.[0]?.legalese || "",
        officerComments:
          selectSignatureData?.signature?.[0]?.officerComments || "",
        signerComments:
          selectSignatureData?.signature?.[0]?.signerComments || "",
      });
    } else {
      setFormValues(null);
    }
  }, [selectSignatureData, isEdit]);

  useEffect(() => {
    if (isNonEmptyVariable(formValues)) {
      form.setFieldsValue(formValues);
    } else {
      form.resetFields();
    }
  }, [formValues]);

  useEffect(() => {
    if (!show) {
      form.resetFields();
    }
  }, [show]);

  const onModalHide = () => {
    onHide();
  };

  const onSaveClick = () => {
    if(!isSignImgUploaded && !fullSearch){
      showDialog("info", {
        title: "Warning",
        content: "Signature is mandatory",
        confirmButtonText: "Ok",
      });
      return;
    }
    form.validateFields().then((values) => {
      onSave({
        signature: [
          {
            ...values,
            ...signImgPayload,
          },
        ],
      });
    });
  };

  const saveSignPhotos = (value) => {
    setSignImgPayload(value);
  };
useEffect(()=>{
if(isEdit){
  let allowEdit=hasCheckSecurity(
                 Security_Types.functionality,
                 Entity_types.subModule,
                 LABELS_CAPITAL.MODIFY,
                 MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                 SUB_MODULES_LIST_WITH_ID.Arrest_Report
               )
  if(!allowEdit){
    setIsDisabled(true);
  }else{
    setIsDisabled(false);
  }
}
else{
  setIsDisabled(false);
}
},[isEdit])

  return (
    <>
      <Modal
        header="Signatures Details"
        show={show}
        onHide={onModalHide}
        size="lg"
        footerActions={[
          {
            key: "save",
            text: "Save",
            onClick: onSaveClick,
            disabled: !bookingsFieldsEnabled||isDisabled,
          },
        ]}
        footerCloseAction={()=>setIsDisabled(false)}
        footerCloseActionText="Cancel"
      >
        <SignaturesForm
          form={form}
          setIsSignImgUploaded={setIsSignImgUploaded}
          saveSignPhotos={saveSignPhotos}
          selectSignatureData={selectSignatureData}
          isEdit={isEdit}
          bookingsFieldsEnabled={bookingsFieldsEnabled}
        />
      </Modal>
    </>
  );
};

export default SignaturesFormModal;
